export const ARIA_MENU_TOUCH_POPOVER_OFFSET = 30;
export const ARIA_MENU_DESKTOP_POPOVER_OFFSET = 19;
